(() => {
  if (window.AvoriaAfterProductCounters) {
    window.AvoriaAfterProductCounters.init(document);
    return;
  }

  const preparedCounters = new WeakSet();
  const counterParts = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getCounterParts = (element) => {
    const text = element.textContent.trim();
    const numberMatch = text.match(/\d[\d,.]*/);
    if (!numberMatch) return null;

    const target = Number.parseInt(numberMatch[0].replace(/[^\d]/g, ''), 10);
    if (!Number.isFinite(target)) return null;

    return {
      target,
      prefix: text.slice(0, numberMatch.index),
      suffix: text.slice(numberMatch.index + numberMatch[0].length),
      useThousandsSeparator: numberMatch[0].includes(','),
    };
  };

  const renderValue = (element, parts, value) => {
    const formattedValue = parts.useThousandsSeparator
      ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value)
      : String(value);
    element.textContent = `${parts.prefix}${formattedValue}${parts.suffix}`;
  };

  const animateCounter = (element, parts) => {
    if (element.dataset.counterComplete === 'true') return;
    element.dataset.counterComplete = 'true';

    if (reducedMotion.matches) {
      renderValue(element, parts, parts.target);
      return;
    }

    const duration = Number.parseInt(element.dataset.counterDuration || '1500', 10);
    const startTime = performance.now();
    element.classList.add('is-counting');

    const update = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 4);
      renderValue(element, parts, Math.round(parts.target * easedProgress));

      if (progress < 1) {
        window.requestAnimationFrame(update);
      } else {
        renderValue(element, parts, parts.target);
        element.classList.remove('is-counting');
        element.classList.add('has-counted');
      }
    };

    window.requestAnimationFrame(update);
  };

  const counterObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const parts = counterParts.get(entry.target);
          if (parts) animateCounter(entry.target, parts);
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px 30% 0px',
        threshold: 0.01,
      })
    : null;

  const init = (scope = document) => {
    const counters = scope.matches?.('[data-avoria-counter]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-avoria-counter]') || []);

    counters.forEach((counter) => {
      if (preparedCounters.has(counter)) return;
      preparedCounters.add(counter);

      const parts = getCounterParts(counter);
      if (!parts) return;
      counter.dataset.counterOriginal = counter.textContent.trim();
      counterParts.set(counter, parts);

      if (counterObserver) {
        if (!reducedMotion.matches) renderValue(counter, parts, 0);
        counterObserver.observe(counter);
      } else {
        animateCounter(counter, parts);
      }
    });
  };

  window.AvoriaAfterProductCounters = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
